export interface ErrorHandlerModel {
    message: string
}